import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../environments/environments';
import { Observable } from 'rxjs';
import { KnowledgeDocumentResponse } from '../models/responses/knowledge-document-response';

@Injectable({
  providedIn: 'root'
})
export class KnowledgeBaseService {

  constructor(private httpClient: HttpClient) { }

  uploadKnowledgeWebsite(aiAgentId: number, websiteUrl: string, name: string) {
    return this.httpClient.post<any>(`${environment.knowledgeUrl}/scrape`, { businessId: aiAgentId, url: websiteUrl, name });
  }

  uploadKnowledgePdf(aiAgentId: number, formData: FormData, name: string) {
    return this.httpClient.post<any>(`${environment.knowledgeUrl}/pdf/${aiAgentId}/${name}`, formData);
  }

  fetchForAiAgent(aiAgentId: number): Observable<KnowledgeDocumentResponse[]> {
    return this.httpClient.get<KnowledgeDocumentResponse[]>(`${environment.knowledgeUrl}/fetchForBusiness/${aiAgentId}`);
  }

  deleteDocument(id: number) {
    return this.httpClient.delete(`${environment.knowledgeUrl}/deleteDocument/${id}`);
  }
}
